"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var r=(e=>(e.ASC="asc",e.DESC="desc",e))(r||{});exports.SortingDirection=r;
